import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
import { CurrencyConverterModalComponent } from '@finder/shared/components/currency-converter/modal/currency-converter.modal.component';
import { CurrencyConverterService } from '@finder/shared/components/currency-converter/currency-converter.service';
// eslint-disable-next-line max-len
import { CURRENCY_CONVERTER_WIDGET_ANIMATIONS } from '@finder/shared/components/currency-converter/widget/currency-converter.widget.animation';
import { CommonModule } from '@angular/common';
import { FontIconComponent } from '../../font-icon/font-icon.component';

@Component({
    selector: 'finder-currency-converter-widget',
    templateUrl: './currency-converter.widget.component.html',
    styleUrls: ['./currency-converter.widget.component.scss'],
    animations: [...CURRENCY_CONVERTER_WIDGET_ANIMATIONS],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent
    ]
})
export class CurrencyConverterWidgetComponent implements OnInit, OnDestroy {
    modal: ModalComponent;
    data: any;
    isDisabled = false;
    widgetState: string;
    buttonTooltip: string;
    buttonTitle: string;
    modalTitle: string;

    constructor(
        private modalService: ModalService,
        private currencyConverterService: CurrencyConverterService,
    ) {}

    @HostListener('click', ['$event'])
    showCurrencyConverter() {
        if (this.isDisabled) {
            return;
        }
        if (this.modal) {
            this.modal.open();
        } else {
            this.modal = this.modalService.create(CurrencyConverterModalComponent, {
                dismissOnBackgroundClick: true,
                title: this.buttonTooltip,
                data: this.data,
                id: 'currency-converter-modal'
            });
            this.modal.ready().subscribe(() => {
                this.modal.open();
            });
        }
    }

    ngOnInit() {
        this.currencyConverterService.getExchangeRate().subscribe({
            next: (response) => {
                this.data = response;
                this.buttonTooltip = response.labels.widget.tooltip;
                this.buttonTitle = response.labels.widget.buttonTitle;
                // Reuse Convert button tooltip copy for modal title.
                this.modalTitle = response.labels.widget.tooltip;
                setTimeout(() => this.widgetState = 'loaded');
            },
            error: (response) => {
                this.data = response.error;
                // Disable the CC button and show the error on hover
                this.isDisabled = true;
                this.buttonTooltip = response.error.errors[0];
                this.buttonTitle = response.error.labels.widget.buttonTitle;
                setTimeout(() => this.widgetState = 'loaded');
            }
        });
    }

    ngOnDestroy() {
        if (this.modal) {
            this.modal.close();
        }
    }
}
